import { createContext } from 'react'

const RootRefContext = createContext()
export default RootRefContext
